/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_discount_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Stacked percentage discounts multiply, not add. Taking 20% off first leaves 80% of the price, then 10% off that leaves 90% of that — 0.80 × 0.90 = 0.72, so the combined discount is 28%, not 30%. Applying discounts in either order gives the same 28% result.`)
};

const es_pct_discount_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Los descuentos porcentuales acumulados se multiplican, no se suman. Aplicar primero un 20% de descuento deja el 80% del precio, y un 10% de descuento sobre eso deja el 90% de eso — 0,80 × 0,90 = 0,72, así que el descuento combinado es del 28%, no del 30%. Aplicar los descuentos en cualquier orden da el mismo resultado del 28%.`)
};

const de_pct_discount_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein. Gestaffelte prozentuale Rabatte multiplizieren sich, statt sich zu addieren. 20% Rabatt zuerst lassen 80% des Preises übrig, dann lassen 10% davon 90% davon übrig — 0.80 × 0.90 = 0.72, der kombinierte Rabatt beträgt also 28%, nicht 30%. Die Reihenfolge der Rabatte spielt dabei keine Rolle, das Ergebnis ist in beiden Fällen 28%.`)
};

const nl_pct_discount_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee. Gestapelde percentagekortingen vermenigvuldigen, ze tellen niet op. Eerst 20% korting laat 80% van de prijs over, en dan 10% korting daarop laat 90% van dat bedrag over — 0.80 × 0.90 = 0.72, dus de gecombineerde korting is 28%, niet 30%. De kortingen in beide volgordes toepassen geeft hetzelfde resultaat van 28%.`)
};

const fr_pct_discount_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non. Les réductions en pourcentage cumulées se multiplient, elles ne s’additionnent pas. Appliquer d’abord 20 % de réduction laisse 80 % du prix, puis 10 % de réduction sur ce montant laisse 90 % de celui-ci — 0,80 × 0,90 = 0,72, donc la réduction combinée est de 28 %, pas 30 %. Appliquer les réductions dans un ordre ou dans l’autre donne le même résultat de 28 %.`)
};

const it_pct_discount_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Gli sconti sovrapposti si moltiplicano, non si sommano. Togliendo prima il 20% resta l'80% del prezzo, poi il 10% di sconto su questo lascia il 90% di quel valore — 0.80 × 0.90 = 0.72, quindi lo sconto combinato è del 28%, non del 30%. Applicare gli sconti in un ordine o nell'altro dà lo stesso risultato del 28%.`)
};

const pt_br2_pct_discount_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. Descontos empilhados se multiplicam, não se somam. Tirar 20% primeiro deixa 80% do preço, depois 10% sobre isso deixa 90% daquilo — 0.80 × 0.90 = 0.72, então o desconto combinado é de 28%, não de 30%. Aplicar os descontos em qualquer ordem dá o mesmo resultado de 28%.`)
};

const pt_pct_discount_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. Os descontos percentuais acumulados multiplicam-se, não se somam. Aplicar primeiro 20% de desconto deixa 80% do preço, depois 10% de desconto sobre isso deixa 90% disso — 0.80 × 0.90 = 0.72, logo o desconto combinado é 28%, não 30%. Aplicar os descontos em qualquer ordem dá o mesmo resultado de 28%.`)
};

const ja_pct_discount_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。割引の重ね掛けは足し算ではなく掛け算になります。最初に20%オフすると価格の80%が残り、そこからさらに10%オフするとその90%が残ります — 0.80 × 0.90 = 0.72なので、合計の割引率は30%ではなく28%です。どちらの順番で割引を適用しても、結果は同じ28%になります。`)
};

const zh_pct_discount_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不等于。叠加的百分比折扣是相乘而不是相加。先减 20% 剩下 80% 的价格，再减 10% 剩下其中的 90%——0.80 × 0.90 = 0.72，所以合计折扣是 28% 而不是 30%。无论先应用哪个折扣，结果都是同样的 28%。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_discount_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_discount_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_discount_faq3_a", locale)
	if (locale === "en") return en_pct_discount_faq3_a(inputs)
	if (locale === "es") return es_pct_discount_faq3_a(inputs)
	if (locale === "de") return de_pct_discount_faq3_a(inputs)
	if (locale === "nl") return nl_pct_discount_faq3_a(inputs)
	if (locale === "fr") return fr_pct_discount_faq3_a(inputs)
	if (locale === "it") return it_pct_discount_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_pct_discount_faq3_a(inputs)
	if (locale === "pt") return pt_pct_discount_faq3_a(inputs)
	if (locale === "ja") return ja_pct_discount_faq3_a(inputs)
	return zh_pct_discount_faq3_a(inputs)
};